import styled from "styled-components";
import { mediaMaxWidth } from "../../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: calc(100% - 40px);
`;

export const Form = styled.form`
  width: 500px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
  `}
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  position: relative;
  display: block;
  align-items: center;
  max-width: 490px;
  flex-flow: wrap;

  strong {
    margin: 0 3px;
  }

  span {
    font-weight: 700;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border: ${(props) => props.error !== null && "2px solid #f2008c"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  height: 10em;
  padding: 10px;
  position: relative;
  margin: 30px 0 40px 0;

  ::placeholder {
    opacity: 0.75;
    font-weight: 300;
    font-style: italic;
  }

  &:focus {
    border-color: #f2008c;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.tablet`
    height: 8em;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;

    ${mediaMaxWidth.smallPhone`
      font-size: 0.9em;
      margin: 5px;
    `}
  }
`;

export const Field = styled.div`
  position: relative;
`;

export const ActionConfirmation = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1em;
  flex-direction: column;
  justify-content: space-evenly;

  span {
    font-weight: 700;
    margin: 0 4px;

    &:last-child {
      margin: 0 0 0 4px;
    }
  }
`;

export const ActionConfimationIcon = styled.div`
  font-size: 4em;
  color: #a8a8a8;
`;

export const ActionConfirmationMessage = styled.div`
  width: 500px;
  text-align: center;
`;

export const Error = styled.div`
  position: absolute;
  bottom: -5px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #f2008c;
  font-weight: 600;

  ${mediaMaxWidth.smallPhone`
    bottom: 0;
  `}
`;

export const Note = styled.div`
  position: absolute;
  bottom: 14px;
  font-size: 0.9em;
  font-style: italic;
  left: -5px;
`;

export const Asterisk = styled.div`
  display: inline;
  font-size: 2em;
  top: ${(props) => (props.note ? "11px" : "-5px")};
  position: ${(props) => (props.note ? "relative" : "absolute")};
  margin-right: ${(props) => (props.note ? "5px" : "1px")};
`;

export const PlaceholderBtn = styled.div`
  font-weight: bold;
  background: #9c9c9c;
  border: 1px solid #9c9c9c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  color: #fff;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  cursor: not-allowed;
  min-height: 44px;
  margin: 5px 10px;

  ${mediaMaxWidth.smallPhone`
    font-size: 0.9em;
    margin: 5px;
  `}
`;
